var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100 d-flex flex-column"},[_c('div',{staticClass:"flex-fill"}),_c('div',{class:_vm.slotClass,style:(_vm.slotStyle)},[_vm._t("default")],2),_c('div',{staticClass:"flex-fill"})])}
var staticRenderFns = []

export { render, staticRenderFns }